module.exports = __webpack_public_path__ + "static/media/Lord Voldemort 1.4d8aebdc.jpg";